import { ICollectionMapper } from '../Firestore/ICollectionMapper'
import { IQuickbooksExport, QuickbooksExport } from './QuickbooksExport'

export class QuickbooksExportMapper implements ICollectionMapper<QuickbooksExport> {
  map(data: IQuickbooksExport): QuickbooksExport {
    const quickbooksExport = new QuickbooksExport(data.exportedByUserId, data.exportedByCompanyId)
    quickbooksExport.id = data.id
    quickbooksExport.orderIds = data.orderIds
    quickbooksExport.exportedDate = data.exportedDate

    return quickbooksExport
  }

  serialize(object: QuickbooksExport): IQuickbooksExport {
    return JSON.parse(JSON.stringify(object))
  }
}
